/**
 * Setting up translations plugin.
 * Language imports and bootstrap config are done here
 * @module Language Configs
 * @param {object} - privacy gown
 * @param {object} - security
 * @returns {survival}
 */

// Vue App dependencies
import { createI18n, type ComposerTranslation } from 'vue-i18n'
import { languagesConfigs } from '@/scripts/app-configs/language/languages-configs'

const long = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  weekday: 'long',
  hour: 'numeric',
  minute: 'numeric',
}

const short = {
  month: 'short',
  day: 'numeric',
}

const dateTimeFormats = {
  'en': {
    short,
    long,
  },
  'pt': {
    short,
    long,
  },
}

export const i18n = createI18n({
  ...languagesConfigs.i18nOptions,
  legacy: true,
  globalInjection: true,
  dateTimeFormats,
  missingWarn: false,
})

const t = i18n.global.t as ComposerTranslation

// Keeps our legacy of 'import i18n' to use as 'i18n.t()' intact
export default { t, tc: t, locale: i18n.global.locale }
